import { render, staticRenderFns } from "./trackOrders.vue?vue&type=template&id=9a506e20&"
import script from "./trackOrders.vue?vue&type=script&lang=js&"
export * from "./trackOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports